export const PendoEvents = Object.freeze({
  PROGRAM_VIEWED: "program_viewed",
  PROGRAM_WEBSITE_CLICKED: "program_website_clicked"
});
